export default __webpack_public_path__ + "8fe3809f29793c53ea0134f44381c461.svg";